import { render, staticRenderFns } from "./organization-task-history.vue?vue&type=template&id=41e56b34&"
import script from "./organization-task-history.vue?vue&type=script&lang=js&"
export * from "./organization-task-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports